import React, {FC, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {IState} from "../../types/state";
import cls from "./posts.module.scss"
import Post from "./Post";
import {IPost, IPostCategory, ITag} from "../../types/posts";
import PageHeader from "../shared/PageHeader";
import {TranslationsType} from "../../types/homePageTypes";


interface IProps {
    post: IPost,
    postCategory: IPostCategory
    postTags: Array<ITag>
    postSlug: string,
    dbName: string,
    domain: string,
    layout?: string,
    locale: string,
    sidebarPosition?: string,
    breadcrumb: Array<{ title: string; url: string }>;
    translationsData: TranslationsType;
}

const PostInnerPage: FC<IProps> = ({
                                       locale,
                                       dbName,
                                       domain,
                                       post,
                                       layout,
                                       postSlug,
                                       postCategory,
                                       postTags,
                                       breadcrumb,
                                       translationsData
                                   }) => {
    let content;
    const [redirect, _] = useState();

    const prevPostSlugRef: { current?: string | Array<string> } = useRef()
    const prevLocaleCodeRef: { current?: string | Array<string> } = useRef();

    useEffect(() => {
        prevPostSlugRef.current = postSlug;
        prevLocaleCodeRef.current = locale;
    }, []);

    useEffect(() => {
        if (
            prevPostSlugRef.current !== postSlug ||
            prevLocaleCodeRef.current !== locale
        ) {
            prevPostSlugRef.current = postSlug;
            prevLocaleCodeRef.current = locale;
        }
    }, [postSlug, locale]);

    if (redirect) {
        ///  return router.push("/404");
    }


    content = (
        <div className={`row ${cls.blog_container}`}>
            <Post
                post={post}
                postTags={postTags}
                dbName={dbName}
                layout={layout}
                domain={domain}
                translationsData={translationsData}
            />
        </div>
    );

    return (
        <div className="page">
            <PageHeader dbName={dbName} breadcrumb={breadcrumb}/>
            <div className="container">{content}</div>
        </div>
    );
}

export default PostInnerPage